import { render, staticRenderFns } from "./SliderBook.vue?vue&type=template&id=84cf3730&scoped=true"
import script from "./SliderBook.vue?vue&type=script&lang=js"
export * from "./SliderBook.vue?vue&type=script&lang=js"
import style0 from "./SliderBook.vue?vue&type=style&index=0&id=84cf3730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cf3730",
  null
  
)

export default component.exports